import { KanbanBoard } from './components';
import { useGroupedQueuesStore, visibleQueuesSelector } from '../store';
import { ProductionPlanEmptyState } from '../ProductionPlanEmptyState';
import { useKanbanEventSource } from '../hooks';

export const Kanban = () => {
  const isAllQueuesHidden = useGroupedQueuesStore((state) => visibleQueuesSelector(state).length === 0);

  useKanbanEventSource();

  if (isAllQueuesHidden) {
    return <ProductionPlanEmptyState />;
  }

  return <KanbanBoard />;
};

Kanban.displayName = 'KanbanBoardWrapper';
